module.exports = __webpack_public_path__ + "static/media/Sundus.f77eae0f.png";